var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slogan"},[_vm._v("\n    "+_vm._s(_vm.translate('slogan'))+" "),_c('UIIcon',{staticClass:"icon ml-1",attrs:{"name":['fa', 'check-circle']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }